import React, { useState } from 'react'
import { Container,Row, Col } from 'react-bootstrap'
import { BsThreeDotsVertical } from "react-icons/bs";
import './Add_installation.css';
import { MdDelete } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { FiX, FiUpload } from "react-icons/fi"; // Close & Upload icons
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";



export default function Verification({installDetails, setinstallDetails, isSubmitting,handleSubmit, selectedFile,
  setSelectedFile,}) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
      const locate = useLocation();
  
 const [originalData, setOriginalData] = useState({});


  const[isOpenThreeDots,setIsOpenThreeDots]=useState(false);

  const verifiedCompleted=installDetails?.verification?.isCompleted


  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  



  useEffect(() => {
        axios
          .post(apiUrl+"getdata-install", {
            leadId: locate.state?.leadId,
          })
          .then((res) => {
            setinstallDetails(res.data.message);
            setOriginalData(res.data.message); // Store original data for comparison
          });
      }, [locate.state?.leadId]);


        const planMonth = Number(installDetails?.installplanDetails?.installplanMonth)||0;
const planAmount = Number(installDetails?.installplanDetails?.installplanAmount)||0;
const staticIpCost = Number(installDetails?.installplanDetails?.installstaticIpCost)||0;
const installationCost = Number(installDetails?.installplanDetails?.installinstalationCost)||0;
const routerCost = Number(installDetails?.installplanDetails?.installrouterCost)||0;
const otherCost = Number(installDetails?.installplanDetails?.installothersCost)||0;

const totalPlanAmount = planMonth * planAmount;

const baseAmount = totalPlanAmount + staticIpCost + installationCost + routerCost + otherCost;

const gstAmount = baseAmount * 0.18;

const orderValue = +(baseAmount + gstAmount).toFixed(2);


const formattedOrderValue = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR"
}).format(orderValue);


const plan = installDetails.installplanDetails || {};


const installrouterCost = Number(plan.routerSellingCost) || 0;
const installfiberCost = Number(plan.installfiberCost) || 0;
const installfiberCableMeter = Number(plan.installfiberCableMeter) || 0;
const installottPrice = Array.isArray(plan.installottPrice) ? Number(plan.installottPrice[0]) || 0 : 0;
const installothersCost = Number(plan.installothersCost) || 0;
const OrderScore = baseAmount
  - installrouterCost
  - (installfiberCableMeter * installfiberCost)
  - installottPrice
  - installothersCost;

console.log("OrderScore:", OrderScore);
console.log(baseAmount,'baseamout')


const formattedOrderScore = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR"
}).format(OrderScore);

console.log(installDetails)

      const handleChange = (e) => {
        const { name, value } = e.target;
        setinstallDetails((prev) => ({
          ...prev,
          verification: {
            ...prev.verification,
            [name]: value,
          },
        }));
      };



      const getOptionBackground = (status) => {
  switch (status) {
    case "Open":
      return "#fbdc6e";
    case "Verified":
      return " #b0e9bd ";
    case "Not Available":
      return "#ffa5ee";
    default:
      return "#fbdc6e";
  }
};

  return (
    
    <div>
<Container >

  <form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(installDetails); // Trigger parent submit handler
        }}>

 <div  className='plan-details-container-border mt-3 text-center'>
                            <p style={{ fontSize:"13px"}}  className='pt-2'><span className='text-primary'>{installDetails?.installplanDetails?.installfiberCableMeter}
                            </span> M, <span className='text-primary '>{installDetails?.installplanDetails?.installplanSpeed}
                            </span> Mbps, <span className='text-primary'> {installDetails?.installplanDetails?.installplanMonth}</span>Month @ <span className='text-primary'>Rs. {installDetails?.installplanDetails?.installplanAmount}
                            /-</span></p>
                            <p  style={{ fontSize:"13px"}}>Order Value @ <span className='text-primary'>Rs.{formattedOrderValue}/-</span>, OrderScore @ <span className='text-primary'>Rs.{formattedOrderScore}/-</span></p>
                            
                        </div>
                    


      <div className="modal1-verification-converted mt-5 ">
                             <Container>

                              <Row className='text-start'>
                                <Col>
                               <label>Verification Status</label>
                               <br></br>
                               <select className='form-input-select'
                               onChange={handleChange}
                                 disabled={installDetails?.verification?.isCompleted === true}

                               value={installDetails.verification?.verificationStatus || ""}
                                name='verificationStatus'
                                 style={{
    backgroundColor: getOptionBackground(installDetails.verification?.verificationStatus)
  }}                            
                                   >
                                <option style={{background:"#fbdc6e"}} value="Open">Open</option>
                                <option style={{background:" #b0e9bd"}} value="Verified">Verified</option>

                                <option style={{background:"#ffa5ee"}} value="Not Available">Not Available</option>


                               </select>
                               </Col>
                               <Col>
                               <Col className="date-update-textbox">
                                   <label>Next Follow Up Date</label>
                                   <br />
                                   <input
                                     disabled={installDetails?.verification?.isCompleted === true}

  type="date"
  className="field form-input"
  onChange={handleChange}
  name="nextFollowUpDate" // Ensure this matches the key in your state
  value={installDetails.verification?.nextFollowUpDate || ""}
/>

                                 </Col>
                               </Col>
                               </Row>
   
                               <textarea
                                 style={{
                                   textTransform: "capitalize",
                                   resize: "none",
                                 }}
                                 placeholder="Enter Notes"
                                 className="converted-textbox"
                                 onChange={handleChange}
                                 value={installDetails.verification?.notes || ""}
                                 name="notes"
                                   disabled={installDetails?.verification?.isCompleted === true}

   
                               />
                               <div className="upload-section">
                                 <label className="upload-btn">
                                   <FiUpload className="upload-icon" />
                                   Upload Image
                                   <input
                                     type="file"
                                     accept="image/*"
                                     onChange={handleFileChange}
     disabled={installDetails?.verification?.isCompleted === true}

                                 
                                     hidden
                                   />
                                 </label>
                                 {selectedFile && (
                                   <p className="file-name">{selectedFile.name}</p>
                                 )}
                               </div>
   
                               
                             </Container>
                           </div>

 
{isSubmitting && (
  <div className="verification-photo-upload">
    <Row className="mt-3">
      <Col md={4} sm={4} className="text-center">
        <h6>
          K.Saravanan <span className="text-secondary ms-4">2h</span>
        </h6>
      </Col>

      <Col md={4} sm={4} className="text-start">
        <h5>Installation/Verified</h5>
      </Col>

      <Col md={4} sm={4} className="text-center">
        <span onClick={() => setIsOpenThreeDots(!isOpenThreeDots)}>
          <BsThreeDotsVertical />
        </span>

        {isOpenThreeDots && (
          <div className="threedot-popup">
            <div className="text-end cross-symbol-verification">
              <span onClick={() => setIsOpenThreeDots(false)}>
                <RxCross2 />
              </span>
            </div>

            <Row className="ms-1 mt-1">
              <Col md={2} sm={2}>
                <input type="checkbox" />
              </Col>
              <Col md={10} sm={10} className="text-start">
                Approved
              </Col>
            </Row>

            <Row className="ms-1 mt-2 mb-2">
              <Col md={2} sm={2}>
                <MdDelete />
              </Col>
              <Col md={10} sm={10} className="text-start">
                Delete
              </Col>
            </Row>
          </div>
        )}
      </Col>
    </Row>

    <Row className="mt-4">
      <Col md={2} sm={2}>
        <div className="img-verification-profile ms-4">
          <img
            src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD..."
            width="50px"
            height="50px"
            style={{ borderRadius: "50%" }}
            alt="Profile"
          />
        </div>
      </Col>

      <Col md={9} sm={9}>
        <p>Still Customer Not Paid, already we gave more times.</p>
      </Col>
    </Row>

    <div className="verificatin-photo-background mt-5 mb-5">
      <div className="text-center">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuD8LaNCgp4Txe8LigEYq3Wc0k2eX8f033ZtLCWriItZVNEbHTtvc8hNTyJ_nzLCye2Xc&usqp=CAU"
          width="300px"
          alt="Verification"
        />
      </div>
    </div>
  </div>
)}


  </form>
</Container>


    </div>
  )
}
